import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  page: {
    width: "100%",
  },
  headerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    padding: "18px 22px",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  headerIconBadge: {
    width: 36,
    height: 36,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#e9f5ec",
    color: theme.palette.primary.main,
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  },
  headerTitle: {
    fontWeight: 700,
    color: "#10212a",
    fontSize: 20,
  },
  headerCount: {
    color: "#7a8a92",
    fontSize: 14,
    marginLeft: 6,
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  statsBar: {
    backgroundColor: "#f4f8f5",
    padding: "18px 22px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
  },
  statCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #dce9df",
    borderRadius: 10,
    padding: "16px 18px",
  },
  statLabel: {
    color: "#5b6870",
    fontSize: 13,
    fontWeight: 500,
  },
  statValue: {
    marginTop: 8,
    fontWeight: 700,
    fontSize: 26,
    color: "#10212a",
  },
  statSubtext: {
    marginTop: 4,
    color: "#98A2B3",
    fontSize: 12,
  },
  filterBar: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    padding: "16px 22px",
    borderTop: "1px solid #EEF0F4",
    borderBottom: "1px solid #EEF0F4",
  },
  searchField: {
    flex: "1 1 260px",
    maxWidth: 360,
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#fff",
    },
  },
  filterSelect: {
    minWidth: 130,
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#fff",
    },
  },
  tableContainer: {
    "& .MuiTableCell-root": {
      borderBottom: "1px solid #EEF0F4",
      padding: "14px 16px",
    },
  },
  tableHeadCell: {
    whiteSpace: "nowrap",
  },
  bodyRow: {
    cursor: "pointer",
  },
  contractNameCell: {
    maxWidth: 200,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  contractNameLink: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  referenceText: {
    color: "#5b6870",
    fontSize: 13,
  },
  typeChip: {
    backgroundColor: "#F2F4F7",
    color: "#344054",
    fontWeight: 600,
    fontSize: 12,
    height: 22,
  },
  statusChip: {
    fontWeight: 600,
    fontSize: 12,
    height: 24,
    textTransform: "capitalize",
  },
  statusDraft: {
    backgroundColor: "#EFF6FF",
    color: "#2563EB",
  },
  statusApproved: {
    backgroundColor: "#e9f5ec",
    color: theme.palette.primary.main,
  },
  cellMuted: {
    color: "#98A2B3",
  },
  endDateOverdue: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  emptyState: {
    padding: "48px 16px",
    textAlign: "center",
    color: "#5b6870",
  },
  footerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    padding: "14px 22px",
  },
  footerText: {
    color: "#5b6870",
    fontSize: 13,
  },
  paginationGroup: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  paginationPage: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    fontWeight: 700,
    minWidth: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
  },
}));

export default useStyles;
